import React from 'react';
import styles from './legend.scss';
import StickyElement from '../sticky-element';

class Legend extends React.Component {
  render() {
    return (
      <div className={styles.legend}>
        <div className={styles.legendSection}>
          <div className={styles.legendHeading}>Project Budget</div>
          <div className={styles.legendRow}>
            <span className={styles.legendText}>Less $</span>
            <img
              className={styles.legendImg}
              src={`${process.env.PUBLIC_URL}/img/less-more.svg`}
              alt=""
            />
            <span className={styles.legendText}>More $</span>
          </div>
          <div className={styles.legendRow}>
            <div
              className={`${styles.legendCircle} ${styles.legendCircleStriped}`}
            />
            <div className={styles.legendText}>Budget not specified</div>
          </div>
        </div>
        <div className={styles.legendSection}>
          <div className={styles.legendHeading}>
            Digital Government Priority
          </div>
          <div className={styles.legendRow}>
            <div
              className={`${styles.legendCircle} ${styles.legendCircleGreen}`}
            />
            <div className={styles.legendText}>Customer Experience</div>
          </div>
          <div className={styles.legendRow}>
            <div
              className={`${styles.legendCircle} ${styles.legendCircleBlue}`}
            />
            <div className={styles.legendText}>Digital On The Inside</div>
          </div>
          <div className={styles.legendRow}>
            <div
              className={`${styles.legendCircle} ${styles.legendCircleLightBlue}`}
            />
            <div className={styles.legendText}>Data</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Legend;



// WEBPACK FOOTER //
// ./src/components/legend/legend.js